var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{ref:"tedme",style:(_vm.$vuetify.breakpoint.mobile ? 'min-height:calc(100vh - 96px)' : 'max-height:calc(100vh - 96px)'),attrs:{"src":_vm.setUser(_vm.link),"height":"100%","width":"100%","frameborder":"0"}})}
var staticRenderFns = []

export { render, staticRenderFns }